import styled from 'styled-components';
import checkIcon from '@/assets/icon/checkIcon.svg';
import uncheckIcon from '@/assets/icon/uncheckIcon.svg';

interface FormType {
  name: string;
  phoneNumber: string;
  insuranceType: string;
  insuranceName: string;
  // address: string;
  hospitalAddress: string;
  accidentType: string;
  insuranceAmount: string;
  description: string;
}

interface StepperPropsType {
  form: FormType;
}

const Stepper = ({ form }: StepperPropsType) => {
  return (
    <StepperWrapper>
      <Step top="0px">
        <Icon src={!form.name || !form.phoneNumber ? uncheckIcon : checkIcon} alt="이름, 연락처" />
      </Step>

      <Step top="255px" topSm="203px">
        <Icon src={!form.insuranceName ? uncheckIcon : checkIcon} alt="보험사명" />
      </Step>

      <Step top="643px" topSm="599px">
        <Icon src={!form.hospitalAddress ? uncheckIcon : checkIcon} alt="병원 주소" />
      </Step>

      <Step top="816px" topSm="797px">
        <Icon src={!form.accidentType ? uncheckIcon : checkIcon} alt="사고유형" />
      </Step>

      <Step top="1116px" topSm="1085px">
        <Icon src={!form.insuranceAmount ? uncheckIcon : checkIcon} alt="보험금액" />
      </Step>

      <Step top="1292px" topSm="1286px">
        <Icon src={!form.description ? uncheckIcon : checkIcon} alt="상담내용" />
      </Step>
    </StepperWrapper>
  );
};

export default Stepper;

// ======================= styled-components =======================

const StepperWrapper = styled.ol`
  position: relative;
  border-left: 1px solid #bfdbfe; /* border-s border-blue-100 */
  height: 1312px;

  @media (max-width: 640px) {
    height: 1310px;
  }
`;

const Step = styled.li<{ top: string; topSm?: string }>`
  position: absolute;
  top: ${({ top }) => top};
  left: -12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 9999px;
  background-color: white;

  @media (min-width: 640px) {
    width: 30px;
    height: 30px;
    left: -14px;
    top: ${({ topSm, top }) => topSm ?? top};
  }
`;

const Icon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
